import { render, staticRenderFns } from "./NewsNufffoodsSpectrum.vue?vue&type=template&id=558190c9&scoped=true&"
import script from "./NewsNufffoodsSpectrum.vue?vue&type=script&lang=js&"
export * from "./NewsNufffoodsSpectrum.vue?vue&type=script&lang=js&"
import style0 from "./NewsNufffoodsSpectrum.vue?vue&type=style&index=0&id=558190c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558190c9",
  null
  
)

export default component.exports